/**
 * @description 单据属性类
 * @author: 菩萨蛮
 * @date 2020/2/14 10:01 下午
 * @version V1.2.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行
 *
 * V1.1.0 新增name获取方法，新增两个通用方法
 * V1.2.0 新增sort字段排序功能，优化构造方法结构
 */

import { qxUtils } from '@qxintech/qx-component';
import OrderItem from './OrderItem';

export default class OrderVO {
  constructor(orderItemsObj) {
    this._name = 'OrderVO';
    this._orderItemsObj = orderItemsObj;
    const itemHandler = orderItemKey => {
      const orderItem = orderItemsObj[orderItemKey];
      return new OrderItem({
        param: orderItemKey,
        ...orderItem
      });
    };
    this._orderItems = this.getOrderItems(orderItemsObj, itemHandler);
  }

  // eslint-disable-next-line class-methods-use-this
  getOrderItems(orderItemsObj, itemHandler) {
    const sortCallback = (key1, key2) => {
      const obj1 = orderItemsObj[key1];
      const obj2 = orderItemsObj[key2];
      const getSort = sort => (sort === undefined ? 0 : sort);
      return getSort(obj1.sort) - getSort(obj2.sort);
    };
    return Object.keys(orderItemsObj).sort(sortCallback).map(itemHandler);
  }

  set customize(array) {
    this._customize = array.map(e => new OrderItem({
      ...e,
      param: e.title
    }));
  }

  get customize() {
    return this._customize;
  }

  get name() {
    return this._name;
  }

  get copy() {
    return new OrderVO(this._orderItemsObj);
  }

  /**
   * 获取item
   * @returns {OrderItem[]}
   */
  get items() {
    return this._orderItems.filter(e => e.visible && e.visible.new);
  }

  get itemsCheck() {
    return this._orderItems.filter(e => e.visible && e.visible.check);
  }

  /**
   * 列表组件获取该'单据'的参数列表方法
   * @returns [] 参数列表
   */
  get table() {
    return this._orderItems.filter(e => e.visible && e.visible.table)
      .map(item => ({
        label: item.title,
        prop: item.param,
        type: item.type,
        width: item.style.width,
        fixed: item.style.fixed
      }));
  }

  /**
   * 搜索组件获取该'单据'的参数列表方法
   * @returns [] 参数列表
   */
  get search() {
    return this._orderItems.filter(item => item.search === true).map(item => ({
      name: item.title, param: item.param, type: item.type, selectList: item.selectList
    }));
  }

  getData() {
    const returnObj = {};
    this._orderItems.map(item => {
      returnObj[item.param] = item.value;
      return null;
    });
    return returnObj;
  }

  /**
   * 新增组件获取该'单据'的参数对象方法
   * @returns {{}} 参数对象
   */
  get newData() {
    return this.getData();
  }

  /**
   * 修改组件获取该'单据'的参数对象方法
   * @returns {{}} 参数对象
   */
  get modifyData() {
    return this.getData();
  }

  /**
   * 校验方法
   * @returns {string|null|*} 校验提示字符串
   */
  validate(type = 'new') {
    // 必填却为空的参数列表
    const validateList = this._orderItems
      .filter(item => item.required && item.required[type] && qxUtils.isEmpty(item.value))
      .map(item => item.title);
    // 构造一下提示字符串
    if (validateList.length === 0) {
      return null;
    }
    if (validateList.length > 1) {
      return validateList.join('、');
    }
    return validateList[0];
  }

  setValue(row) {
    this._orderItems.forEach(item => {
      item.value = row[item.param];
    });
  }

  /**
   * 根据字段获取值的方法
   * @param item 字段
   * @returns {any} 结果
   */
  getItemValue(item) {
    let value = '';
    this._orderItems.forEach(e => {
      if (e.param === item) {
        // eslint-disable-next-line prefer-destructuring
        value = e.value;
      }
    });
    return value;
  }

  /**
   * 根据字段设置值的方法
   * @param item 字段
   * @param value 值
   */
  setItemValue(item, value) {
    this._orderItems.forEach(e => {
      if (e.param === item) {
        e.value = value;
      }
    });
  }
}
